/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the difference between camelCase and PascalCase?`)
};

const es_cc_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es la diferencia entre camelCase y PascalCase?`)
};

const de_cc_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist der Unterschied zwischen camelCase und PascalCase?`)
};

const nl_cc_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is het verschil tussen camelCase en PascalCase?`)
};

const fr_cc_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la différence entre camelCase et PascalCase ?`)
};

const it_cc_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la differenza tra camelCase e PascalCase?`)
};

const pt_br2_cc_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre camelCase e PascalCase?`)
};

const pt_cc_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre camelCase e PascalCase?`)
};

const ja_cc_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`camelCase と PascalCase の違いは何ですか？`)
};

const zh_cc_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`camelCase 和 PascalCase 有什么区别？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_faq1_q", locale)
	if (locale === "en") return en_cc_faq1_q(inputs)
	if (locale === "es") return es_cc_faq1_q(inputs)
	if (locale === "de") return de_cc_faq1_q(inputs)
	if (locale === "nl") return nl_cc_faq1_q(inputs)
	if (locale === "fr") return fr_cc_faq1_q(inputs)
	if (locale === "it") return it_cc_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_cc_faq1_q(inputs)
	if (locale === "pt") return pt_cc_faq1_q(inputs)
	if (locale === "ja") return ja_cc_faq1_q(inputs)
	return zh_cc_faq1_q(inputs)
};